import { render, staticRenderFns } from "./stickys.vue?vue&type=template&id=6c44065d&"
import script from "./stickys.vue?vue&type=script&lang=js&"
export * from "./stickys.vue?vue&type=script&lang=js&"
import style0 from "./stickys.vue?vue&type=style&index=0&id=6c44065d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports